module.exports = __webpack_public_path__ + "img/logo.793125d7.svg";